module.exports = __webpack_public_path__ + "static/media/ir.23e0f96c.svg";